import {
	EExportFileTypes,
	EMenuActionsTypes,
	EMIMETypes,
	ETechnologiesLabels,
	ETechnologiesValues,
} from '@enums/common';

export const accessToken = 'accessToken';
export const DEFAULT_ZOOM_LVL = 10;
export const DEFAULT_CLUSTER_ZOOM_LVL = 18;
export const MIN_SCROLL_BOTTOM_HEIGHT = 70;
export const DEFAULT_CELLS_VISIBLE_PART_MAX_WIDTH = 500;
export const DEFAULT_CELL_PADDING = 15;
export const DEFAULT_SECTOR_ZOOM_LEVEL = 16;
export const MIN_FILTER_WIDTH = '200px';
export const MAX_CONTAINER_WIDTH = '1176px';
export const LARGE_MAX_CONTAINER_WIDTH = '1920px';
export const DEFAULT_MODAL_HEIGHT = '80vh';
export const FLAT_NODE_PATH_SEPARATOR = '/';

export const FULL_WIDTH_SIDEBAR = '255px';

export const CLOSE_WIDTH_SIDEBAR = '64px';

export const weekDayShortNames = {
	Monday: 'M',
	Tuesday: 'T',
	Wednesday: 'W',
	Thursday: 'T',
	Friday: 'F',
	Saturday: 'S',
	Sunday: 'S',
};

export const monthsOptions = [
	{ label: 'January', value: 0 },
	{ label: 'February', value: 1 },
	{ label: 'March', value: 2 },
	{ label: 'April', value: 3 },
	{ label: 'May', value: 4 },
	{ label: 'June', value: 5 },
	{ label: 'July', value: 6 },
	{ label: 'August', value: 7 },
	{ label: 'September', value: 8 },
	{ label: 'October', value: 9 },
	{ label: 'November', value: 10 },
	{ label: 'December', value: 11 },
];

export const YEAR_RANGE = 10;
export const HALF_SECOND = 500;
export const DAY_IN_MS = 1000 * 60 * 60 * 24;
export const TWO_MINUTES = 1000 * 60 * 2;

export const keycloakDefaultRoles = [
	'default-roles-idams',
	'offline_access',
	'uma_authorization',
];

export const ASSETS_REQUEST_DELAY = 0;

export const zoomLevelsOptions = [
	{ value: 12, label: 12 },
	{ value: 13, label: 13 },
	{ value: 14, label: 14 },
	{ value: 15, label: 15 },
	{ value: 16, label: 16 },
	{ value: 17, label: 17 },
	{ value: 18, label: 18 },
	{ value: 19, label: 19 },
	{ value: 20, label: 20 },
	{ value: 21, label: 21 },
	{ value: 22, label: 22 },
];

export const SEARCH_DELAY_ON_MAP = 100;

export const refetchOptions = {
	refetchOnReconnect: false,
	refetchOnWindowFocus: false,
	refetchOnmount: false,
	staleTime: 1000 * 60 * 60 * 24,
};

export const ASSET_BY_ID = 'Asset ID';
export const ASSET_BY_ADDRESS = 'Address';

export const mapSearchFiltersOptions = [
	{
		value: ASSET_BY_ID,
		label: ASSET_BY_ID,
		id: ASSET_BY_ID,
		checked: true,
		disabled: false,
	},
	{
		value: ASSET_BY_ADDRESS,
		label: ASSET_BY_ADDRESS,
		id: ASSET_BY_ADDRESS,
		checked: false,
		disabled: false,
	},
];

export const exportAssetsDefaultRules = {
	adLocality: true,
	adPostCode: true,
	adPropertyNoName: true,
	adStreetName: true,
	adTownCity: true,
	assetAccessDetails: true,
	assetId: true,
	assetOwnerNotes: true,
	assetSiteAvailabilityDetails: true,
	assetSiteAvailabilityStatus: true,
	assetSubType: true,
	assetType: true,
	backhaulAccessibilityDetails: true,
	backhaulAccessibilityStatus: true,
	easting: true,
	height: true,
	indicativeAcceptablePricing: true,
	isAvailable: true,
	lastVerificationDate: true,
	lat: true,
	lng: true,
	locationDescription: true,
	maxOperators: true,
	northing: true,
	powerSupplyAvailabilityDetails: true,
	powerSupplyAvailabilityStatus: true,
	responsible: true,
	siteAvailabilityReviewDate: true,
	specialImplementationIssueDetails: true,
	specialImplementationIssuesExist: true,
	uprn: true,
};

export const menuActionWithoutSelection = [
	{
		text: 'Current page',
		id: EMenuActionsTypes.currentPage,
		disabled: false,
	},
	{
		text: 'All filtered',
		id: EMenuActionsTypes.allFiltered,
		disabled: false,
	},
	{
		text: 'All',
		id: EMenuActionsTypes.all,
		disabled: false,
	},
];

export const menuActions = [
	{
		text: 'Selected on current page',
		id: EMenuActionsTypes.selected,
		disabled: false,
	},
	...menuActionWithoutSelection,
];

export const importSitesActions = [
	{
		text: ETechnologiesLabels.T_4G_TDD,
		id: ETechnologiesValues.T_4G_TDD,
		disabled: false,
	},
	{
		text: ETechnologiesLabels.T_4G_FDD,
		id: ETechnologiesValues.T_4G_FDD,
		disabled: false,
	},
	{
		text: ETechnologiesLabels.T_5G,
		id: ETechnologiesValues.T_5G,
		disabled: false,
	},
];

export const exportAssetsRadioButtonsData = [
	{
		label: 'CSV',
		name: EExportFileTypes.csv,
		disabled: false,
		defaultChecked: true,
	},
	{
		label: 'KML',
		name: EExportFileTypes.kml,
		disabled: false,
		defaultChecked: false,
	},
	{
		label: 'Shapefile',
		name: EExportFileTypes.shape,
		disabled: true,
		defaultChecked: false,
	},
	{
		label: 'XLSX',
		name: EExportFileTypes.xlsx,
		disabled: false,
		defaultChecked: false,
	},
	{
		label: 'KMZ',
		name: EExportFileTypes.kmz,
		disabled: false,
		defaultChecked: false,
	},
];

export const exportRadioButtonsData = [
	{
		label: 'CSV',
		name: EExportFileTypes.csv,
		disabled: false,
		defaultChecked: true,
	},
	{
		label: 'XLSX',
		name: EExportFileTypes.xlsx,
		disabled: false,
		defaultChecked: false,
	},
];

export const acquireAssetsExportRadioButtons = [
	{
		label: 'CSV',
		name: EExportFileTypes.csv,
		disabled: false,
		defaultChecked: true,
	},
	{
		label: 'XLSX',
		name: EExportFileTypes.xlsx,
		disabled: false,
		defaultChecked: false,
	},
	{
		label: 'KMZ',
		name: EExportFileTypes.kmz,
		disabled: false,
		defaultChecked: false,
	},
	{
		label: 'KML',
		name: EExportFileTypes.kml,
		disabled: false,
		defaultChecked: false,
	},
];

export const exportDashboardPORadioButtonsData = [
	{
		label: 'CSV',
		name: EExportFileTypes.csv,
		disabled: false,
		defaultChecked: true,
	},
	{
		label: 'XLSX',
		name: EExportFileTypes.xlsx,
		disabled: false,
		defaultChecked: false,
	},
];

export const RulesCheckboxesData = {
	basicInfo: [
		{
			label: 'Asset ID',
			name: 'assetId',
		},
		{
			label: 'Asset type',
			name: 'assetType',
		},
		{
			label: 'Asset subtype',
			name: 'assetSubType',
		},
		{
			label: 'UPRN',
			name: 'uprn',
		},
		{
			label: 'Responsible',
			name: 'responsible',
		},
		{
			label: 'Price',
			name: 'indicativeAcceptablePricing',
		},
		{
			label: 'Max operators',
			name: 'maxOperators',
		},
		{
			label: 'Height',
			name: 'height',
		},
		{
			label: 'Last verification date',
			name: 'lastVerificationDate',
		},
		{
			label: 'Site availability review date',
			name: 'siteAvailabilityReviewDate',
		},
		{
			label: 'Notes',
			name: 'assetOwnerNotes',
		},
	],
	address: [
		{
			label: 'Property No./Name',
			name: 'adPropertyNoName',
		},
		{
			label: 'Street name',
			name: 'adStreetName',
		},
		{
			label: 'Locality',
			name: 'adLocality',
		},
		{
			label: 'Town/City',
			name: 'adTownCity',
		},
		{
			label: 'Postcode',
			name: 'adPostCode',
		},
		{
			label: 'Location description',
			name: 'locationDescription',
		},
		{
			label: 'Latitude',
			name: 'lat',
		},
		{
			label: 'Longitude',
			name: 'lng',
		},
		{
			label: 'Easting',
			name: 'easting',
		},
		{
			label: 'Northing',
			name: 'northing',
		},
	],
	attributes: [
		{
			headerText: 'Backhaul Accessibility Status',
			nameStatus: 'backhaulAccessibilityStatus',
			nameDetails: 'backhaulAccessibilityDetails',
		},
		{
			headerText: 'Power Supply Availability Status',
			nameStatus: 'powerSupplyAvailabilityStatus',
			nameDetails: 'powerSupplyAvailabilityDetails',
		},
		{
			headerText: 'Asset Site Availability Status',
			nameStatus: 'assetSiteAvailabilityStatus',
			nameDetails: 'assetSiteAvailabilityDetails',
		},
		{
			headerText: 'Asset Site Access Availability',
			nameStatus: 'isAvailable',
			nameDetails: 'assetAccessDetails',
		},
		{
			headerText: 'Special Implementation Issues Exist',
			nameStatus: 'specialImplementationIssuesExist',
			nameDetails: 'specialImplementationIssueDetails',
		},
	],
};

export const fileExtensions = {
	[EMIMETypes.png]: 'png',
	[EMIMETypes.doc]: 'doc',
	[EMIMETypes.docx]: 'docx',
	[EMIMETypes.xls]: 'xls',
	[EMIMETypes.xlsx]: 'xlsx',
	[EMIMETypes.txt]: 'txt',
	[EMIMETypes.ppt]: 'ppt',
	[EMIMETypes.pptx]: 'pptx',
	[EMIMETypes.jpeg]: 'jpg',
	[EMIMETypes.pdf]: 'pdf',
	[EMIMETypes.csv]: 'csv',
	[EMIMETypes.svg]: 'svg',
	[EMIMETypes.kml]: 'kml',
	[EMIMETypes.kmz]: 'kmz',
	[EMIMETypes.zip]: 'zip',
	[EMIMETypes.xml]: 'xml',
	[EMIMETypes.json]: 'json',
	[EMIMETypes.yang]: 'yang',
};

export const polygonFileTypesWithoutMapping = ['kml', 'zip'];

export const distanceTooltipMessages = {
	'GREEN': 'Distance <5m and Same Side Rd',
	'AMBER': 'Distance 5m-15m and Same Side Rd',
	'RED': 'Distance >15m or Need to Cross Rd',
};

export const HUNDRED_PERCENT_LOADING = 100;

export const INVALID_DATE = 'Invalid Date';

export const booleanOptions = [
	{
		label: 'Yes',
		name: 'Yes',
		value: true,
	},
	{
		label: 'No',
		name: 'No',
		value: false,
	},
];

export const timezoneUTC = 'UTC';

export const MAX_IMPORT_LINES = 5000;

export const DEFAULT_START_DATE = 0;

export const oneHundredYearsInMilliseconds = 100 * 365 * 24 * 60 * 60 * 1000;

export const DEFAULT_END_DATE = new Date().getTime() + oneHundredYearsInMilliseconds;

export const formatTemplateDefault = 'dd/MM/yyyy';

export const formatTemplateWithTime = 'dd/MM/yyyy hh:mm a';

export const DEFAULT_DECIMAL_PRESICION = 2;

export const MEGA_BYTE = 1024 * 1024;

export const DEFAULT_ADMIN_PANEL_ROUTES = {
	sideBarItems: [],
	routesList: [],
	firstNotHiddenItem: undefined,
	isLoading: false,
};

export const defaultBrandingSetupName = 'Default setup';

export const linkedTasksStatusNames = {
	active: 'ACTIVE',
	inactive: 'INACTIVE',
};

export const linkedTasksStatusTitles = {
	active: 'Active',
	inactive: 'Inactive',
};

export const portalTasksStatuses = {
	toDo: 'TO_DO',
	inProgress: 'IN_PROGRESS',
	done: 'DONE',
};

export const portalTasksPriorities = {
	low: 'LOW',
	medium: 'MEDIUM',
	high: 'HIGH',
};

export const WINDOW_HEIGHT_THRESHOLD = 1080;

export const EXPORT_MENU_MIN_WIDTH = 222;

export const DEFAULT_5G_TECHNOLOGY = '5G';
export const ORAN_5G_TECHNOLOGY = '5G O-RAN';

export const COPY_TIMEOUT = 2000;

export const STORAGE_KEYS = {
	ORGANIZATION_ID: 'organizationId',
	PLATFORM_OWNER_ADMINISTRATOR: 'platformOwnerAdministrator',
	ORG_SWITCH_RELOAD_FLAG: 'orgSwitchReload',
} as const;
